import { render } from "./Home.vue?vue&type=template&id=306bc230&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-306bc230"

export default script